const isNull = (param) => param === null

class Level {
  constructor({
    levelName = null,
    levelId = null,
    groupId = null,
    groupName = null,
  } = {}) {
    this.levelName = isNull(levelName) ? null : levelName
    this.levelId = isNull(levelId) ? null : levelId
    this.groupId = isNull(groupId) ? null : groupId
    this.groupName = isNull(groupName) ? null : groupName
  }
}
export class ChipLevel extends Level {
  constructor({ isSelected = false, ...props } = {}) {
    super(props)
    this.isSelected = isNull(isSelected) ? null : isSelected
  }
}

export const parseLevelsFromArray = (levels = []) =>
  levels.map((e) => new ChipLevel({ levelId: e.id, levelName: e.typeLevel }))

export const parseGroupsFromArray = (gradeGroups = []) =>
  gradeGroups
    .map((e) =>
      e.ggs.map(
        (x) =>
          new ChipLevel({
            groupId: x.id,
            levelId: e.id,
            levelName: e.typeLevel,
            groupName: `${x.grade} ${x.group}`,
          })
      )
    )
    .flat()

export const parseSubGroups = (items = []) =>
  items.map(
    (e) =>
      new ChipLevel({
        groupId: e.id,
        levelId: e.idLevel,
        levelName: e.level.typeLevel,
        groupName: e.name,
      })
  )

export class Student {
  constructor({ id = null, firstName = null, lastName = null } = {}) {
    this.id = isNull(id) ? null : id
    this.firstName = isNull(firstName) ? null : firstName
    this.lastName = isNull(lastName) ? null : lastName
    this.fullName = `${this.firstName} ${this.lastName}`
  }
}
export class ChipStudent extends Student {
  constructor({ isSelected = false, ...props } = {}) {
    super(props)
    this.isSelected = isNull(isSelected) ? null : isSelected
  }
}

export const parseChipStudentsFromArray = (students = []) =>
  students.map((e) => new ChipStudent(e))
